import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin as SpinAntd } from 'antd';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Spin = (props) => {
  const { children } = props;
  return (
    <SpinAntd indicator={antIcon} {...props}>
      {children}
    </SpinAntd>
  );
};

export default Spin;
